<template>
  <div>
    <b-modal
      centered
      id="ModalAddList"
      size="sm"
      modal-class="custom-dialog dialog-600"
      hide-footer
      :title="'Crear Nueva Lista'"
      @close="close"
    >
      <form-render
        :form.sync="form"
        :fields="fields"
        ref="formRenderNewList"
        containerButtonsClass="col-sm-4 mt-2"
        :key="keyFormRender"
      >
      </form-render>
      <div class="footer-modal-coverage">
        <b-button class="float-right mt-1 mb-1" variant="outline-success" @click="ok" :disabled="loading.createList">
          <span v-if="!loading.createList" class="mb-1">Confirmar</span>
          <span class="mt-1 p-2" v-if="loading.createList"><b-spinner small  /> </span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'

export default {
  name: 'ModalAddList',
  props: ['getLists', 'formCountryCourier'],
  data() {
    return {
      form: {},
      fields: [],
      keyFormRender: 0,
      loading: {
        createList: false
      },
      baseService: new BaseServices(this)
    }
  },
  computed: {
    ...mapGetters({
      countries: 'getCountriesInCurrentCoverage',
      carriers: 'getCarriersForCountry'
    })
  },
  watch: {
    countries() {
      this.setOptions('countries', 'country')
      const resetFields = ['country', 'carrier']
      resetFields.forEach(el => this.setSkeletonField(el, false))
    },
    carriers() {
      this.setOptions('carriers', 'carrier')
      const resetFields = ['carrier']
      resetFields.forEach(el => this.setSkeletonField(el, false))
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.form = this.formCountryCourier
      this.fields = [
        { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, name: 'country', disabled: true, label: 'País', containerClass: 'col-sm-12 fieldSelect', change: this.changeCountry, addFlags: true, validation: 'required', sort: true },
        { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, name: 'carrier', label: 'Courier', containerClass: 'col-sm-12', dependency: 'country', sort: true, disabled: true},
        { fieldType: 'FieldInput', name: 'listName', label: 'Nombre de lista', containerClass: 'col-sm-12 container-info', validation: 'required', dependency: 'carrier' },
        { fieldType: 'FieldTextarea', name: 'descriptionList', label: 'Descripción', containerClass: 'col-sm-12 container-info', validation: 'required', dependency: 'carrier' }
      ]
      this.$store.dispatch('fetchService', { name: 'getCountriesInCurrentCoverage' })
    },
    setOptions(name, fieldName) {
      this.fields[this.m_getElementIndex(this.fields, 'name', fieldName)].options = this[name].rows
    },
    setSkeletonField (name, bool) {
      this.fields[this.m_getElementIndex(this.fields, 'name', name)].useSkeleton = bool
      this.fields[this.m_getElementIndex(this.fields, 'name', name)].useLabel = bool
    },
    changeCountry(name, value) {
      if (value) {
        this.setSkeletonField('carrier', true)
        this.$store.dispatch('fetchService', { name: 'getCarriersForCountry', params: { country_id: value.id } })
      }
      this.showTable = false
    },
    async ok() {
      const isCheck = await this.$refs.formRenderNewList.onlyCheckForm()
      const queryParams = {
        name: this.form.listName,
        description: this.form.descriptionList,
        default: false,
        carrier_id: this.form.carrier.id
      }
      if (isCheck) this.createPricesList({queryParams})
    },
    createPricesList(data) {
      this.loading.createList = true
      this.baseService.callService('postCreatePricesLists', data.queryParams)
        .then(response => {
          this.$newSuccess('¡Se ha creado la nueva lista!', 'small')
          setTimeout(() => {
            this.$emit('getLists')
          }, 200)
        })
        .catch((err) => {
          this.$newError('Ha ocurrido un problema', err.msg, 'large')
        })
        .finally(() => {
          setTimeout(() => {
            this.loading.createList = false
            this.close()
          }, 200)
        })
    },
    close() {
      delete this.form.listName
      delete this.form.descriptionList
      this.$bvModal.hide('ModalAddList')
    }
  }
}
</script>